<template>
  <div class="excode">
    <div class="excode-form">
      <div class="excode-title">{{ $t('excode.redemptioncode') }}</div>
      <el-form :model="form" :rules="rules" ref="ruleUser" inline>
        <el-form-item prop='excode'>
          <el-input
              v-model.trim="form.excode"
              class="excode-input"
              :placeholder="$t('excode.pleaseredemptioncode')"/>
        </el-form-item>
        <el-form-item class="excode-btn">
          <el-button type="primary" class="table-header-btn" @click="tomarketexchange">{{ $t('excode.exchange') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
<!--    <el-data-table ref="table" v-bind="tableConfig" :columns="columns">-->
<!--    </el-data-table>-->
    <template v-if="tableList&&tableList.length>0">
      <el-table
          :data="tableList"
          class="w-100">
        <el-table-column
            prop="id"
            label="No">
        </el-table-column>
        <el-table-column
            prop="name"
            label="Name">
        </el-table-column>
        <el-table-column
            prop="excode"
            :label="$t('excode.redemptioncode')">
        </el-table-column>
        <el-table-column
            :label="$t('excode.status')">
          <template v-slot="scope">
            {{ filterObj(statusOptions,'value',scope.row.status).label }}
          </template>
        </el-table-column>
        <el-table-column
            prop="exchangetime"
            :label="$t('excode.exchangetime')">
        </el-table-column>
        <el-table-column
            prop="createTime"
            :label="$t('excode.createtime')">
        </el-table-column>
        <el-table-column
            width="130px"
            :label="$t('aftersales.operate')">
          <template v-slot="scope">
            <el-button :disabled="scope.row.status!='1'" type="text" icon="el-icon-folder-checked"
                       @click="exChangeTable(scope.row)">{{ $t('excode.exchange') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="large tr mt-2">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
      <div class="small tr mt-2">
        <el-pagination
            @currenct-change="handleCurrentChange"
            :current-page="page"
            small
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </template>
    <!-- 暂无数据-->
    <div v-else class="empty">
      <img :src="`${$g.imgPrefix}/img/common/no-result.webp`">
      <div class="empty-text">{{$t('friends.nodata')}}</div>
    </div>

    <!-- 兑换码核销-->
    <el-dialog
        :title="$t('excode.redemptioncode')"
        :visible.sync="dialogFormVisible"
        :width="screenWidth>576.98?'400px':'85%'"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false">
      <el-form :model="form1">
        <!-- 购买类型-->
        <el-form-item :label="$t('home.buytyp')">
          <el-select v-model="form1.type" :placeholder="$t('excode.selectactivityarea')" @change="buyTypeChange">
            <el-option
                v-for="(tItem,tIndex) in typeList"
                :key="tIndex"
                :value="tItem.value"
                :label="tItem.label"/>
          </el-select>
        </el-form-item>
        <!-- 可选车票-->
        <el-form-item :label="$t('excode.optionaltraintickets')">
          <el-select :placeholder="$t('excode.selectactivityarea')" v-model="form1.ticket" @change="tickChange">
            <el-option v-for="item in ticketlist" :key="item.id"
                       :label="item.useremail+' ['+item.seatno+']'" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- 取消-->
        <el-button @click="dialogFormVisible = false">{{$t('friends.cancel')}}</el-button>
        <!-- 确认-->
        <el-button type="primary" @click="handleExchange">{{$t('luckdraw.comfirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserExcode,
  exchange,
  marketexchange,
  getTicketList
} from "@/request/requests";
import {
  getUserInfo,
  startLoading,
  MessageSuccess,
  MessageError,
  filterObj
} from "@/util/util"

export default {
  name: "excode",
  data() {
    const statusOptions = [
      {
        value: "1",
        // label:"not used"
        // label:"사용하지 않았다"
        label: this.$t('excode.notused'),
      },
      {
        value: "2",
        // label:"Used"
        // label:"이미 사용 된"
        label: this.$t('excode.used'),
      },
      {
        value: "3",
        // label:"Expired"
        // label:"만료"
        label: this.$t('excode.expired'),
      },
    ]
    const columns = [
      {
        prop: 'id',
        label: 'No'
      },
      {
        prop: 'name',
        label: 'Name'
      },
      // {prop: 'excode',label: 'Redemption code'},
      {
        prop: 'excode',
        label: this.$t('excode.redemptioncode')
      },
      // {prop: 'status',label: 'Status',formatter: row => this.statusState(row)},
      {
        prop: 'status',
        label: this.$t('excode.status'),
        formatter: row => this.statusState(row)
      },
      // {prop: 'exchangetime',label: 'Exchange date'},
      {
        prop: 'exchangetime',
        label: this.$t('excode.exchangetime')
      },
      // {prop: 'createTime',label: 'createTime'},
      {
        prop: 'createTime',
        label: this.$t('excode.createtime')
      },

    ]
    return {
      typeList:[
        {
          //新购
          value:'1',
          label: this.$t('excode.newpurchase')
        },
        {
          //续费
          value:'2',
          label: this.$t('excode.renew')
        }
      ],
      tableList: [],
      page: 1,
      size: 10,
      total: 0,
      screenWidth: null,
      dialogFormVisible: false,
      showflag: false,
      newBuyFlag: false,
      renewFlag: false,
      excode: '',
      userid: null,
      id: null,
      ticketlist: null,
      form1: {
        type: '',
        ticket: ''
      },
      form: this.initForm(),
      rules: {
        excode: [
          // {required: true, message: 'Please enter the redemption code', trigger: 'blur'},],
          // {required: true, message: '请输入兑换码', trigger: 'blur'},],
          // {required: true, message: '상환 코드를 입력하세요', trigger: 'blur'},],
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('excode.redemptioncode'),
            trigger: 'blur'
          },
        ],

      },
      userinfo: "",
      statusOptions,
      columns,
      tableConfig: {
        url: 'userexcode/getByUserId',
        dataPath: 'data.list',
        totalPath: 'data.total',
        paginationSize: 10,
        extraButtons: [{
          type: 'primary',
          // text: 'exchange',
          text: this.$t('excode.exchange'),
          icon: 'el-icon-folder-checked',
          disabled: (row) => {
            if (row.status == '1') {
              return false
            } else {
              return true
            }
          },
          atClick: async (row) => {
            this.form1.type = ''
            this.form1.ticket = null
            this.userinfo = await getUserInfo()
            if (this.userinfo) {
              this.userid = JSON.parse(this.userinfo).id
            }
            this.dialogFormVisible = true
            this.excode = row.excode
            this.id = row.id

            return false
          },
        },],
        headerButtons: [],
        hasDelete: false,
        hasEdit: false,
        hasOperation: true,
        hasNew: false,
        operationAttrs: {
          width: '100px',
          fixed: 'right',
        },
      },
    }
  },
  methods: {
    filterObj,
    initForm() { //初始数据
      return {
        excode: "", // 兑换码
      }
    },
    async exChangeTable(row){
      this.form1.type = ''
      this.form1.ticket = null
      this.userinfo = await getUserInfo()
      if (this.userinfo) {
        this.userid = JSON.parse(this.userinfo).id
      }
      this.dialogFormVisible = true
      this.excode = row.excode
      this.id = row.id
    },
    async getTableList(){
      let params = {
        size: this.size,
        page: this.page
      }
      let res = await getUserExcode(this.$qs.stringify(params))
      if (res.status === "200") {
        this.tableList = res.data?.list;
        this.total = res.data?.total;
      } else {
        MessageError(res.msg);
      }
    },
    handleSizeChange(val) {
      this.size = val;
      this.page = 1;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.size = val;
      this.getTableList();
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    },
    async handleExchange() {

      /**
       *①查看兑换码是否是新购吗，并且同时产看是否具有同类的车票
       *②如果是新购码，并且没有同类有效车票，则弹出框只显示新购按钮链接
       *③如果是新购吗，并且具有同类有效车票，则弹出框显示新购和可选择车票下拉

       *④如果不是新购码 并且具有同类有效车票，则弹出框显示可选择车票下拉框

       ***/

          // let data = {
          // 	id: row.id,
          // 	excode: row.excode,
          // 	userid: this.userinfo.id
          // }

      let data = {
            id: this.id,
            excode: this.excode,
            userid: this.userid,
            ticketid: this.form1.ticket
          }


      let loading = startLoading()
      let res = await exchange(data)
      if (res.status == "200") {
        loading.close()
        MessageSuccess(res.msg)
      } else {
        loading.close()
        MessageError(res.msg)
      }
      loading.close()
      this.$refs.table.getList()
    },

    buyTypeChange(val) {
      //续费
      if (val === '2') {
        getTicketList(this.excode, this.userid).then(res => {
          this.ticketlist = res.data
        })
      } else {
        this.ticketlist = []
      }
    },


    tickChange(val) {
      this.form1.ticket = val
    },

    statusState(row) {
      let data
      this.statusOptions.forEach(r => {
        if (r.value == row.status) {
          data = r.label
        }
      })
      return data
    },
    tomarketexchange() {
      this.$refs.ruleUser.validate((valid) => {
        if (valid) {
          this.id = null;
          //this.operator()
          this.dialogFormVisible = true
          this.excode = this.form.excode
          this.userid = this.userinfo.id
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async operator() {
      let data = {
        excode: this.form.excode,
        userid: this.userinfo.id
      }
      let loading = startLoading()
      let res = await marketexchange(data)
      if (res.status == "200") {
        this.form = this.initForm();
        this.$refs.ruleUser.clearValidate();
        loading.close()
        MessageSuccess(res.msg)
      } else {
        loading.close()
        MessageError(res.msg)
      }
      loading.close()
    }
  },
  mounted() {
    let userInfo = getUserInfo()
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo)
      this.tableConfig.axiosConfig = {
        headers: {
          'Authorization': 'X-KILOGOD-AUTHORIZATION ' + this.$cookies.get('token'),
        }
      }
      this.getTableList();
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
.excode {
  &-form{
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:110px;
    @media (max-width:768px) {
      display:revert;
      margin-bottom:60px;
    }
  }
  &-title{
    font-size:20px;
    font-weight: bold;
    @media (max-width:768px) {
      margin-bottom:20px;
    }
  }
  &-input{
    width:250px;
  }
  &-btn{
    vertical-align: sub;
    margin-left:10px;
  }
  ::v-deep .el-form{
    &-item{
      margin-bottom:0;

    }
  }
}

.excode-btn.el-form-item{
  @media (max-width:576.98px) {
    width: 100%;
    text-align: right;
    margin-right:0!important;
    margin-left:0!important;
  }
}
::v-deep .el-dialog{
  .el-button{
    font-size:14px;
    padding: 20px 40px !important;
    border-radius: 34px !important;
    width: calc(100% / 2 - 20px);
    @media(max-width:575.98px){
      padding:10px 40px!important;
    }
  }
}
::v-deep .dialog-footer{
  display:flex;
  justify-content: space-between;
}

.empty{
  width: 220px;
  text-align: center;
  margin: 0 auto;
  img{
    width:100%;
  }
}
</style>